import { Button, Input } from 'antd';
import { SearchOutlined } from '@ant-design/icons';
import { makeStyles } from '@material-ui/styles';
import { useTranslation } from 'react-i18next';
import PropTypes from 'prop-types';
import React, { useEffect, useState } from 'react';

const useStyles = makeStyles(
  theme => ({
    wrapper: {
      width: 260,
      padding: '8px',
      boxShadow: theme.shadow.modal,
      borderRadius: theme.borderRadius.min,
    },
    button: {
      width: '100%',
      marginTop: 8,
    },
    icon: {
      color: theme.colors.gray1,
    },
  }),
  { name: 'TableSearchInput' },
);

const TableSearchInput = ({ onClick, value }) => {
  const { t } = useTranslation();
  const classes = useStyles();

  const [inputValue, setValue] = useState(value);

  const handleChangeInputValue = e => {
    setValue(e?.target?.value);
  };

  const handleSearch = () => {
    onClick(!!inputValue ? inputValue : undefined);
  };

  useEffect(() => {
    if (value !== inputValue) {
      setValue(value);
    }
  }, [value]);

  return (
    <div className={classes.wrapper}>
      <Input
        placeholder="Search"
        defaultValue={value}
        value={inputValue}
        onChange={handleChangeInputValue}
        allowClear
      />
      <Button type="primary" size="small" className={classes.button} onClick={handleSearch}>
        <SearchOutlined className={classes.icon} />
        {t('Search')}
      </Button>
    </div>
  );
};

TableSearchInput.propTypes = {
  onClick: PropTypes.func.isRequired,
  value: PropTypes.string,
};

export default TableSearchInput;
